import React from 'react';
import { Router } from 'react-static';
import styled from 'styled-components';

// eslint-disable-next-line import/no-unresolved
import Routes from 'react-static-routes';

const AppStyle = styled.div`
  height: 100%;
`;

const App = () => (
  <Router autoScrollToHash={false}>
    <AppStyle>
      <Routes />
    </AppStyle>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/App.js